export default window.devicePixelRatio || 1;
